// extracted by mini-css-extract-plugin
export var layoutContainer = "_79-0";
export var layoutContainerNoRounding = "_79-6";
export var layoutContainerOpen = "_79-5";
export var layoutContainerResizing = "_79-1";
export var mainContent = "_79-2";
export var resizeDivider = "_79-3";
export var slidePanel = "_79-4";